var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7 5H5.3C4.31 5 3.509 5.7875 3.509 6.75L3.5 17.25C3.5 18.2125 4.31 19 5.3 19H19.7C20.69 19 21.5 18.2125 21.5 17.25V6.75C21.5 5.7875 20.69 5 19.7 5ZM18.8 17.25H6.2C5.705 17.25 5.3 16.8562 5.3 16.375V8.5L11.546 12.2975C12.131 12.6562 12.869 12.6562 13.454 12.2975L19.7 8.5V16.375C19.7 16.8562 19.295 17.25 18.8 17.25ZM12.5 11.125L5.3 6.75H19.7L12.5 11.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5ae3cbbc31b5079aabec854fa02e4af6.svg";
export { ForwardRef as ReactComponent };